import './YesNoPopup.css';

function YesNoPopup({ handleYes, handleNo, message = '' }) {
    let outputMessage = message || 'Are you sure you want to clear the data?';

    return (
        <div className="yes-no-popup">
            <div className="popup-content">
                <p dangerouslySetInnerHTML={{ __html: outputMessage }}></p> {/* Render message as HTML */}
                <button onClick={handleYes} className="yes-button">Yes</button>
                <button onClick={handleNo} className="no-button">No</button>
            </div>
        </div>
    );
}

export default YesNoPopup;